import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';

const Auth0ProviderWithNavigate = ({ children }) => {
const navigate = useNavigate();

const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;

const onRedirectCallback = (appState) => {
navigate(appState?.returnTo || window.location.pathname);
};

if (!(domain && clientId)) {
return null;
}

return (
    <Auth0Provider
        domain={domain}
        clientId={clientId}
        authorizationParams={{
            redirect_uri: window.location.origin,
        }}
        onRedirectCallback={onRedirectCallback}
        cacheLocation="localstorage"
        >
        {children}
        </Auth0Provider>
    );
};

export default Auth0ProviderWithNavigate;